import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API || "https://www.vilaro.ro/api";
const card = { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)" };
const inputStyle = { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", color: "white", outline: "none" };
const btnPrimary = { background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white" };
const btnGray = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.7)" };

const actionStyles = {
  reply: { background: "rgba(99,102,241,0.15)", color: "#a5b4fc", label: "Reply" },
  hide: { background: "rgba(234,179,8,0.15)", color: "#fde047", label: "Ascuns" },
  block: { background: "rgba(249,115,22,0.15)", color: "#fdba74", label: "Blocat" },
  resolve: { background: "rgba(34,197,94,0.15)", color: "#86efac", label: "Rezolvat" },
  reclassify: { background: "rgba(139,92,246,0.15)", color: "#c4b5fd", label: "Reclasificat" },
  new_comment: { background: "rgba(20,184,166,0.15)", color: "#5eead4", label: "Comentariu nou" },
  delete_comment: { background: "rgba(239,68,68,0.15)", color: "#fca5a5", label: "Șters" },
  autopilot_block: { background: "rgba(239,68,68,0.2)", color: "#f87171", label: "🤖 Auto-blocat" },
};

export default function Activity() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [totals, setTotals] = useState({});
  const [users, setUsers] = useState([]);
  const [filterUser, setFilterUser] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const perPage = 50;

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ limit: perPage, offset: page * perPage });
      if (filterUser) params.append("username", filterUser);
      if (filterAction) params.append("action", filterAction);
      const res = await axios.get(`${API}/activity-log?${params}`);
      setLogs(res.data.logs);
      setTotal(res.data.total);
      setTotals(res.data.totals);
      setUsers(res.data.users);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { fetchLogs(); }, [filterUser, filterAction, page]);

  const totalAll = Object.values(totals).reduce((a, b) => a + b, 0);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white">Jurnal Activitate</h2>
        <p className="text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.35)" }}>Toate acțiunile utilizatorilor în sistem</p>
      </div>

      {/* Totale */}
      <div className="grid grid-cols-4 gap-3 mb-6">
        <div className="rounded-xl p-4 text-center" style={card}>
          <p className="text-2xl font-bold text-white">{totalAll}</p>
          <p className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.4)" }}>Total acțiuni</p>
        </div>
        {Object.entries(actionStyles).map(([action, style]) => totals[action] ? (
          <div key={action} className="rounded-xl p-4 text-center" style={card}>
            <p className="text-2xl font-bold" style={{ color: style.color }}>{totals[action]}</p>
            <p className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.4)" }}>{style.label}</p>
          </div>
        ) : null)}
      </div>

      {/* Filtre */}
      <div className="flex gap-3 mb-4 flex-wrap">
        <select className="rounded-xl px-3 py-2 text-sm" style={inputStyle}
          value={filterUser} onChange={e => { setFilterUser(e.target.value); setPage(0); }}>
          <option value="" style={{ color: "black" }}>Toți utilizatorii</option>
          {users.map(u => <option key={u} value={u} style={{ color: "black" }}>{u}</option>)}
        </select>
        <select className="rounded-xl px-3 py-2 text-sm" style={inputStyle}
          value={filterAction} onChange={e => { setFilterAction(e.target.value); setPage(0); }}>
          <option value="" style={{ color: "black" }}>Toate acțiunile</option>
          {Object.entries(actionStyles).map(([action, style]) => (
            <option key={action} value={action} style={{ color: "black" }}>{style.label}</option>
          ))}
        </select>
        <button onClick={fetchLogs} className="px-3 py-2 rounded-xl text-sm" style={btnGray}>🔄</button>
        <span className="text-xs self-center" style={{ color: "rgba(255,255,255,0.3)" }}>{total} înregistrări</span>
      </div>

      {/* Lista */}
      {loading ? (
        <div className="text-center py-12 text-sm" style={{ color: "rgba(255,255,255,0.3)" }}>Se încarcă...</div>
      ) : (
        <div className="space-y-2">
          {logs.map(log => {
            const style = actionStyles[log.action] || { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.5)", label: log.action };
            return (
              <div key={log.id} className="rounded-xl p-3 flex items-start gap-3" style={card}>
                <div className="flex-shrink-0 w-24 text-right">
                  <p className="text-xs" style={{ color: "rgba(255,255,255,0.4)" }}>
                    {new Date(log.created_at.includes('Z') || log.created_at.includes('+') ? log.created_at : log.created_at.replace(' ', 'T') + 'Z').toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' })}
                  </p>
                  <p className="text-xs" style={{ color: "rgba(255,255,255,0.25)" }}>
                    {new Date(log.created_at.includes('Z') || log.created_at.includes('+') ? log.created_at : log.created_at.replace(' ', 'T') + 'Z').toLocaleDateString('ro-RO')}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: "rgba(99,102,241,0.15)", color: "#a5b4fc" }}>
                    {log.username}
                  </span>
                </div>
                <div className="flex-shrink-0">
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: style.background, color: style.color }}>
                    {style.label}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  {log.comment_from_name && (
                    <span className="text-xs font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>
                      {log.comment_from_name}
                    </span>
                  )}
                  {log.details && (
                    <p className="text-xs mt-0.5 truncate" style={{ color: "rgba(255,255,255,0.4)" }}>
                      {log.details}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
          {logs.length === 0 && (
            <div className="text-center py-12 text-sm" style={{ color: "rgba(255,255,255,0.2)" }}>Nicio activitate înregistrată</div>
          )}
        </div>
      )}

      {total > perPage && (
        <div className="flex items-center justify-center gap-3 mt-6">
          <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0}
            className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-30" style={btnGray}>← Anterior</button>
          <span className="text-xs" style={{ color: "rgba(255,255,255,0.4)" }}>{page + 1} / {Math.ceil(total / perPage)}</span>
          <button onClick={() => setPage(p => p + 1)} disabled={(page + 1) * perPage >= total}
            className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-30" style={btnGray}>Următor →</button>
        </div>
      )}
    </div>
  );
}
